import React from 'react';

import * as Sentry from '@sentry/react';

export type SentryErrorBoundaryProps = React.PropsWithChildren<{
  extras?: Parameters<Sentry.Scope['setExtras']>[0];
  fallback: Sentry.ErrorBoundaryProps['fallback'];
}>;

/** NOTE
 * In development mode, React will rethrow errors caught within an error boundary to the global error handler. This will result in Sentry only reporting an error from the global error handler, but not from the error boundary itself. We recommend testing the error boundary with a production build of React.
 */
export const SentryErrorBoundary = ({
  extras,
  ...rest
}: SentryErrorBoundaryProps) => (
  <Sentry.ErrorBoundary
    {...rest}
    beforeCapture={extras ? (scope) => scope.setExtras(extras) : undefined}
  />
);
